import { useRef, useEffect, useMemo } from 'react'
import { useFormikContext } from 'formik'

export const useIxFocusElement = (values: any, itemsData: any, lastFocusedElement: any, activeDivRef: any, divRef: any=null) => {
    const prevInitialValues: any = useRef(values)
    const { touched } = useFormikContext<any>()
    const hasTouchedFieldRef = useRef(false)

    useEffect(() => {
        hasTouchedFieldRef.current = Object.values(touched).some((value) => value === true)
    }, [touched])

    // const hasTouchedField = useMemo(() => Object.values(touched).some((value) => value === true), [touched])

    const focusButtons = (element: any, lastFocusedElement: any, radioBtnName: string, checkboxBtnName: string, nextCheckboxBtnName: string ) => {
        const activeCheckboxBtns: any = element?.querySelectorAll('.dx-checkbox.dx-state-focused')

        // focuses radio button
        element?.querySelector('.dx-state-focused.dx-radiobutton')?.classList.remove('dx-state-focused')
        setTimeout(() => {
            const radioBtn: any = element?.querySelector(`[name="${radioBtnName}"] + div`)?.querySelectorAll(`[role='radio']`)
            if (radioBtn?.length) {
                if (!element?.id.includes('form')) {
                    element.classList.contains('dx-drawer-panel-content') &&
                        element.querySelector('[aria-label="filter"]').focus()
                        element.querySelector('[aria-label="filter"]').classList.remove('dx-state-focused')
                    element.classList.contains('dx-drawer-content') && (element.querySelector('.dx-scrollable-container') as any).focus()
                }
                else { (element.closest('.dx-scrollable-container') as any)?.focus() }
                radioBtn[0]?.classList.add('dx-state-focused')
                lastFocusedElement.current = radioBtn[0]
            }
        }, 1000)

        // focuses checkbox button
        activeCheckboxBtns?.forEach((item: any) => {item.classList.remove('dx-state-focused')})
        setTimeout(() => {
            const checkboxBtn: any = element?.querySelector(`[name="${checkboxBtnName}"]`)?.closest('[role="checkbox"]') || element?.querySelector(`[name="${nextCheckboxBtnName}"]`)?.closest('[role="checkbox"]')
            if (checkboxBtn) {
                checkboxBtn?.classList.add('dx-state-focused')
                checkboxBtn?.focus()
                lastFocusedElement.current = checkboxBtn
            }
        }, 200)
    }

    useEffect(() => {
        if (!hasTouchedFieldRef.current) { prevInitialValues.current = values; return }

        const element: HTMLElement = activeDivRef
        if (!element?.id.includes('form')) {
            if (((divRef?.current as any)?.closest('.dx-drawer-content') || (divRef?.current as any)?.closest('.dx-drawer-panel-content')) !== element) {
                prevInitialValues.current = values
                return
            }
        }

        const timeoutId = setTimeout(() => {
            const fields = itemsData.filter((item: any) => item.type === 'field').map((item: any) => element?.querySelectorAll<HTMLInputElement>((`[name="${item.name}"]`))[item.index])

            itemsData.map((x: any) => x.name).every((field: any) => {
                const prevValue = prevInitialValues.current[field]
                if ((values as any)[field] !== prevValue && !(values as any)[field] && (values as any)[field] !== 0) {
                    prevInitialValues.current = values
                    return false
                }
                if ((values as any)[field] !== prevValue && ((values as any)[field] || (values as any)[field] === 0)) {
                    const fieldWithValue: any = itemsData.find((item: any) => item.name === field)
                    const indexElementForFocus: any = itemsData.indexOf(fieldWithValue) + 1
                    const nextField = element?.querySelectorAll<HTMLInputElement>(`[name="${itemsData[indexElementForFocus].name}"]`)[itemsData[indexElementForFocus].index]
                    const activeCheckboxBtns: any = element?.querySelectorAll('.dx-checkbox.dx-state-focused')

                    if (nextField?.getAttribute('aria-readonly') !== 'true' && nextField?.getAttribute('aria-disabled') !== 'true' && nextField) {
                        (element.querySelectorAll<HTMLInputElement>(`[name="${itemsData[itemsData.indexOf(fieldWithValue)]?.name}"]`)[itemsData[itemsData.indexOf(fieldWithValue)]?.index] as any)?.blur()
                        setTimeout(() => {
                            if (!activeCheckboxBtns.length) {
                                lastFocusedElement.current = nextField
                                nextField?.focus()
                            }
                        }, 0)
                        indexElementForFocus !== 0 && focusButtons(
                            element,
                            lastFocusedElement,
                            itemsData[indexElementForFocus]?.name,
                            itemsData[itemsData.indexOf(fieldWithValue)]?.name,
                            itemsData[indexElementForFocus]?.name
                        )
                        prevInitialValues.current = values
                    }
                    else {
                        (element?.querySelectorAll<HTMLInputElement>(`[name="${itemsData[itemsData.indexOf(fieldWithValue)]?.name}"]`)[itemsData[itemsData.indexOf(fieldWithValue)]?.index] as any)?.blur()
                        const ableToFocusItem: any = fields.slice(indexElementForFocus+1).find((item: any) => item?.getAttribute('aria-readonly') !== 'true' && item?.getAttribute('aria-disabled') !== 'true')
                        setTimeout(() => {
                            if (!activeCheckboxBtns?.length) {
                                ableToFocusItem && ableToFocusItem.focus()
                                lastFocusedElement.current = ableToFocusItem
                            }
                        }, 0)

                        indexElementForFocus !== 0 && focusButtons(
                            element,
                            lastFocusedElement,
                            ableToFocusItem?.name,
                            itemsData[itemsData.indexOf(fieldWithValue)]?.name,
                            ableToFocusItem?.name
                        )
                        prevInitialValues.current = values
                    }
                    return false
                }
                return true
            })
        }, 100)

        return () => clearTimeout(timeoutId)
    },[values, itemsData, lastFocusedElement, divRef, activeDivRef])
}
